<perfect-scrollbar
  [disabled]="disabled"
  [style.max-height.px]="maxScrollbarHeight || null"
>
  <ng-content></ng-content>
</perfect-scrollbar>
